import { cn } from "@lib/utils";

interface SpinnerProps {
  className?: string;
}

export default function Spinner({ className }: SpinnerProps) {
  return (
    <div
      className={cn(
        "loader",
        "w-10 h-10 border-4 border-black/10 border-l-[#3b82f6]",
        className
      )}
    >
      <style jsx>{`
        .loader {
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}
